<div class="progress-bar-container ng-star-inserted" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate" color="warn" ></mat-progress-bar>
</div>